import { grayPaletteDark } from '../../themes/dark-colors';
import { bluePalette, grayPalette, greenPalette, redPalette, yellowPalette } from '../../themes/colors';

export const badgeDarkTheme = {
  success: { color: greenPalette[700] },
  warning: { color: yellowPalette[700] },
  danger: { color: redPalette[600] },
  announcement: { color: bluePalette[600] },
  info: { color: grayPalette[500] },
  fontColor: grayPaletteDark[1000],
};
